import { useContext } from "react";
import { ToasterContext } from "../providers/toaster-provider";


export const useToaster = () => {
    return useContext(ToasterContext);
};